import type { WithTokenParams } from 'src/app/shared/types';

import { useSubmit } from '../useSubmit';

export function useWithToken(): (params: WithTokenParams) => Promise<void> {
	const submit = useSubmit();
	return async function withToken(params): Promise<void> {
		return submit(params);
	};
}
